import { z } from 'zod';

import { chatUiBase } from '../../shared/schema/base.js';

/** Um dia do mapa de calor: faixa de preço 1 (mais barato) … 5 (mais caro). A célula
 *  é só cor: `price` (o total do grupo, na `currency` do bloco) viaja SÓ para a conta
 *  da economia estimada da saia do planner (#5246) e nunca é desenhado por dia.
 *  Opcional: o bloco persistido antes dele replaya igual, sem economia. */
const HeatDaySchema = z.object({
  date: z.iso.date(),
  tier: z.number().int().min(1).max(5),
  price: z.number().nonnegative().optional(),
});
/** Calor de uma perna (ida ou volta). `anchorDate` presente → caso datado (CTA "Manter"). */
export const LegHeatSchema = z.object({
  monthLabel: z.string().optional(),
  anchorDate: z.iso.date().optional(),
  cheapestDate: z.iso.date(),
  days: z.array(HeatDaySchema).min(1),
});
export type ChatUiLegHeat = z.infer<typeof LegHeatSchema>;

/** Par de datas escolhido (ida + volta opcional). Um shape só evita drift entre
 *  o `cheapest` do card e a seleção ecoada (`FlightCheaperDatesSelectionSchema`). */
const dateChoiceShape = {
  outboundDate: z.iso.date(),
  returnDate: z.iso.date().optional(),
} as const;

/** Membro `flight_cheaper_dates` do `ChatUiSchema`. Heatmap por perna, SEM valores. */
export const FlightCheaperDatesBlockSchema = z
  .object({
    ...chatUiBase,
    kind: z.literal('flight_cheaper_dates'),
    /** Marcador da interação (toque → search). Congela o card ao resolver. */
    challengeId: z.string().min(1),
    route: z.object({
      origin: z.string().min(1),
      destination: z.string().min(1),
      originLabel: z.string().optional(),
      destinationLabel: z.string().optional(),
    }),
    outbound: LegHeatSchema,
    return: LegHeatSchema.optional(),
    cheapest: z.object(dateChoiceShape),
  })
  .strict();
export type FlightCheaperDatesBlock = z.infer<typeof FlightCheaperDatesBlockSchema>;

/** Escolha de data ecoada em confirmation.selections quando o cliente toca o
 *  card flight_cheaper_dates. Ids = datas ISO; o agents roteia direto p/ search_flights. */
export const FlightCheaperDatesSelectionSchema = z.object(dateChoiceShape).strict();
export type FlightCheaperDatesSelection = z.infer<typeof FlightCheaperDatesSelectionSchema>;
